import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Skeleton } from 'primeng/skeleton';
import { CARE_PLAN_DIALOG_OPTIONS } from '../../care-plan-dialog.options';
import { CarePlanCardListComponent } from '../../shared/care-plan-card-list/care-plan-card-list.component';
import { ActionCardComponent } from '../action-card/action-card.component';
import {
  ActionEditorDialogComponent,
  ActionEditorDialogData,
} from '../action-editor-dialog/action-editor-dialog.component';
import { CarePlanActionsStore } from '../actions.store';

@Component({
  selector: 'bn-actions-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionCardComponent, CarePlanCardListComponent, Skeleton],
  providers: [CarePlanActionsStore, DialogService],
  templateUrl: './actions-section.component.html',
  styleUrl: './actions-section.component.scss',
})
export class ActionsSectionComponent {
  private readonly _dialog = inject(DialogService);
  protected readonly store = inject(CarePlanActionsStore);

  readonly caseId = input.required<string>();
  readonly readonly = input(false);

  constructor() {
    effect(() => {
      const caseId = this.caseId();
      if (caseId) void this.store.load(caseId);
    });
  }

  openAdd(): void {
    if (this.readonly() || !this.store.canCreate()) return;
    this._dialog.open(ActionEditorDialogComponent, {
      ...CARE_PLAN_DIALOG_OPTIONS,
      width: '42rem',
      breakpoints: { '768px': 'calc(100vw - 2rem)' },
      styleClass: 'bn-action-editor-dialog-host',
      data: {
        mode: 'add',
        entryPoint: 'care_plan_case',
        editor: this.store,
      } satisfies ActionEditorDialogData,
    });
  }
}
